import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  extractCarrierByIdFailed,
  extractCarrierByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* extractCarrierById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/registries/carriers/${action.payload.id}/extract`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK || dataResponse.status === CREATED) {
      yield put(extractCarrierByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(extractCarrierByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(extractCarrierByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
